/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscription_Rights_Musculation_AccessInputs */

const fr_admin_subscription_rights_musculation_access = /** @type {(inputs: Admin_Subscription_Rights_Musculation_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès musculation`)
};

/**

* @param {Admin_Subscription_Rights_Musculation_AccessInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_musculation_access = /** @type {((inputs?: Admin_Subscription_Rights_Musculation_AccessInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_Musculation_AccessInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_musculation_access(inputs)
});